export const SOLUTION_ROUTE = "/solution"
export const WEBREATHE_ROUTE = "/webreathe"
export const CONTACT_US = "/contactUs"
export const OUR_TEAM = "/ourTeam"
export const FORTE_DETAILS_ROUTE = "/fortedetails"
